import { Observable, OperatorFunction, tap } from "rxjs";
import { map } from "rxjs/operators";

export function toSuccess<T, P>(
  mapToSuccessAction: Function
): OperatorFunction<T, P> {
  return (source$: Observable<T>) =>
    source$.pipe(map((response: T) => mapToSuccessAction(response)));
}
